export function PmsFilledSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/pms-filled.svg'"></ng-include>`
    }
}